<p-dialog [(visible)]="mfaDeviceLoginAsk" (onShow)="clearState()" [modal]="true" [closable]="true" showEffect="fade" [style]="{width: '25rem'}">
    <div class="mfa-spinner" *ngIf="mfaSpinner">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <ng-template pTemplate="header">
        <div class="w-full text-center">
            <b class="text-3xl" >{{'login.mfa.device-login-title' | translate}}</b>
            <div class="text-xl">{{'login.mfa.device-login-subtitle' | translate}}</div>
        </div>
    </ng-template>
    <div>
        <div class="p-fluid p-formgrid grid">
            <div class="col-12 pb-0">
                <label class="label">{{'login.mfa.activation-code' | translate}} <i class="pi pi-info-circle" (click)="infoActivationCode($event)"></i> </label>
                <p-confirmPopup [style]="{width: '15rem'}" key="infoActivationCode"></p-confirmPopup>
                <input class="label text-center" pInputText type="text" [(ngModel)]="activationCode" (ngModelChange)="clearActivationCodeErrors()" placeholder="{{'login.mfa.activation-code-placeholder' | translate}}"
                    (blur)="activationCodeErrorRequired = isEmpty(activationCode)" [ngClass]="{'ng-invalid ng-dirty': activationCodeErrorWrong || activationCodeErrorRequired}"/>
                <small *ngIf="!activationCodeErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !activationCodeErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
                <small *ngIf="activationCodeErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !activationCodeErrorWrong}">
                    {{'login.mfa.activation-code-fail' | translate}}
                </small>
            </div>
        </div>
        <p-divider layout="horizontal" styleClass="w-full mt-1 mb-4"></p-divider>
        <div outsideClick (outsideClick)="pinContainerHideFromDeviceLogin()">
            <div class="p-fluid p-formgrid grid">
                <div class="col-12">
                    <input pInputText #pinContainerInput [(ngModel)]="pin" class="label text-center"
                    [ngClass]="{'pin-container-box-show' : pinContainerShow}"
                    [ngClass]="{'ng-invalid ng-dirty': pinErrorWrong || pinErrorRequired}"
                    [readOnly]="true" (click)="pinContainerClick()" (ngModelChange)="clearPinErrors()"
                    type="{{ pinInputTypePassword ? 'password' : 'text' }}"
                    (focus)="pinContainerInput.blur()"
                    placeholder="{{'login.mfa.pin-placeholder-login' | translate}}"/>
                </div>
            </div>
            <div class="pin-container-box" [ngClass]="{'pin-container-box-hide' : !pinContainerShow}">
                <div class="pin-container gap-3">
                    <div *ngFor="let pinInput of pinInputList" pInputText (click)="pinInputClick(pinInput)"
                     class="pin-btn flex justify-content-center align-items-center cursor-pointer select-none"> {{pinInput}}
                    </div>
                    <div pInputText (click)="pinInputHideClick()"
                    class="pin-btn flex justify-content-center align-items-center cursor-pointer select-none">
                    <i *ngIf="pinInputTypePassword" class="pi pi-eye"></i>
                    <i *ngIf="!pinInputTypePassword" class="pi pi-eye-slash"></i>
                   </div>
                    <div pInputText (click)="pinContainerClear()"
                    class="pin-btn-dark flex justify-content-center align-items-center cursor-pointer no-hover select-none text-white">
                      {{ 'login.mfa.delete-btn' | translate }}
                   </div>
                </div>
            </div>
            <small *ngIf="!pinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinErrorRequired}">
                {{'login.erreurs.champ-obligatoire' | translate}}
            </small>
            <small *ngIf="pinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinErrorWrong}">
                {{'login.mfa.pin-fail' | translate}}
                <br>
                {{'login.mfa.pin-fail-retry' | translate}}
            </small>
          <div class="col-12 text-center pb-0">
            <a class="text-primary hover:underline cursor-pointer font-medium" (click)="resetPopUpPinShow($event)">{{'login.pin_oublie' | translate}}</a>
          </div>
        </div>
        <p-divider layout="horizontal" styleClass="mt-2 mb-4"></p-divider>
        <div class="p-fluid p-formgrid grid">
            <div class="col-12 pb-0">
                <label class="label">{{'login.mfa.device-name' | translate}} <i class="pi pi-info-circle" (click)="infoDeviceName($event)"></i> </label>
                <p-confirmPopup [style]="{width: '15rem'}" key="infoDeviceName"></p-confirmPopup>
                <div class="p-inputgroup">
                    <input class="label" pInputText type="text" [(ngModel)]="deviceName" (ngModelChange)="clearDeviceNameErrors()" placeholder="{{'login.mfa.device-name-placeholder' | translate}}"
                        [ngClass]="{'ng-invalid ng-dirty': deviceNameErrorRequired}"/>
                    <button pButton pRipple (click)="resetDeviceName()" icon="pi pi-replay"></button>
                </div>
                <small class="w-20rem p-error" [ngClass]="{'soft-hidden': !deviceNameErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
            </div>
            <div class="col-12">
                <label>{{'login.mfa.input-required' | translate}}</label>
            </div>
        </div>

    </div>
    <ng-template pTemplate="footer">
        <div class="w-full">
            <button pButton id="device-login-save" (click)="deviceLoginAndSaveSubmit()" label="{{'login.mfa.submit-save' | translate}}" class="w-full p-button mb-2"> <img [src]="'assets/layout/images/mfa_add_device_icon.svg'"/> </button>
            <button pButton id="device-login" icon="pi pi-check" (click)="deviceLoginSubmit()" label="{{'login.mfa.submit-no-save' | translate}}" class="w-full p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="mfaRegisterAsk" [modal]="true" (onShow)="clearState()" [closable]="true" showEffect="fade" [style]="{'width': '25rem'}">
    <div class="mfa-spinner" *ngIf="mfaSpinner">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <ng-template pTemplate="header">
        <div class="w-full text-center">
            <b class="text-3xl" >{{'login.mfa.register-title' | translate}}</b>
            <div class="text-xl">{{'login.mfa.register-subtitle' | translate}}</div>
        </div>
    </ng-template>
    <div>
        <div class="p-fluid p-formgrid grid">
            <div class="col-12 pb-0">
                <label class="label">{{'login.mfa.activation-code' | translate}} <i class="pi pi-info-circle" (click)="infoActivationCode($event)"></i> </label>
                <p-confirmPopup [style]="{width: '15rem'}" key="infoActivationCode"></p-confirmPopup>
                <input class="label" pInputText type="text" [(ngModel)]="activationCode" (ngModelChange)="clearActivationCodeErrors()" placeholder="{{'login.mfa.activation-code-placeholder' | translate}}"
                    (blur)="activationCodeErrorRequired = isEmpty(activationCode)" [ngClass]="{'ng-invalid ng-dirty': activationCodeErrorWrong || activationCodeErrorRequired}"/>
                <small *ngIf="!activationCodeErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !activationCodeErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
                <small *ngIf="activationCodeErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !activationCodeErrorWrong}">
                    {{'login.mfa.activation-code-fail' | translate}}
                </small>
            </div>
            <p-divider layout="horizontal" class="w-full"></p-divider>
            <div class="col-12 pb-0">
                <label class="label">{{'login.mfa.pin' | translate}}</label>
                <p-password [(ngModel)]="pin" (keydown)="numbersOnly($event)" (ngModelChange)="clearPinErrors()" [toggleMask]="true" [feedback]="false" placeholder="{{'login.mfa.pin-placeholder' | translate}}"
                   (onBlur)="pinErrorRequired = isEmpty(pin)" [ngClass]="{'ng-invalid ng-dirty': pinErrorWrong || pinErrorRequired}" ></p-password>
                <small *ngIf="!pinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
                <small *ngIf="pinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinErrorWrong}">
                    {{'login.mfa.pin-def-fail' | translate}}
                </small>
            </div>
            <div class="col-12 pb-0">
                <label class="label">{{'login.mfa.conf-pin' | translate}}</label>
                <p-password [(ngModel)]="pinConf" (keydown)="numbersOnly($event)" (ngModelChange)="clearPinConfErrors()" [toggleMask]="true" [feedback]="false" placeholder="{{'login.mfa.conf-pin-placeholder' | translate}}"
                    (onBlur)="pinConfErrorRequired = isEmpty(pinConf)" [ngClass]="{'ng-invalid ng-dirty': pinConfErrorWrong || pinConfErrorRequired}" ></p-password>
                <small *ngIf="!pinConfErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinConfErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
                <small *ngIf="pinConfErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinConfErrorWrong}">
                    {{'login.mfa.pin-conf-fail' | translate}}
                </small>
            </div>
            <p-divider layout="horizontal" class="w-full"></p-divider>
            <div class="col-12 pb-0">
                <label class="label">{{'login.mfa.device-name' | translate}} <i class="pi pi-info-circle" (click)="infoDeviceName($event)"></i> </label>
                <p-confirmPopup [style]="{width: '15rem'}" key="infoDeviceName"></p-confirmPopup>
                <div class="p-inputgroup">
                    <input class="label" pInputText type="text" [(ngModel)]="deviceName" (ngModelChange)="clearDeviceNameErrors()" placeholder="{{'login.mfa.device-name-placeholder' | translate}}"
                        [ngClass]="{'ng-invalid ng-dirty': deviceNameErrorRequired}" />
                    <button pButton pRipple (click)="resetDeviceName()" icon="pi pi-history"></button>
                </div>
                <small class="w-20rem p-error" [ngClass]="{'soft-hidden': !deviceNameErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
            </div>
            <div class="col-12">
                <label>{{'login.mfa.input-required' | translate}}</label>
            </div>
        </div>

    </div>
    <ng-template pTemplate="footer">
        <div class="w-full">
            <button pButton id="device-register-save" (click)="registerAndSaveSubmit()" label="{{'login.mfa.submit-save' | translate}}" class="w-full p-button mb-2"> <img [src]="'assets/layout/images/mfa_add_device_icon.svg'"/> </button>
            <button pButton id="device-register" icon="pi pi-check" (click)="registerSubmit()" label="{{'login.mfa.submit-no-save' | translate}}" class="w-full p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="mfaResetPinAsk" [modal]="true" (onShow)="clearState()" [closable]="true" (onHide)="clearState()" showEffect="fade" [style]="{'width': '25rem'}">
    <div class="mfa-spinner" *ngIf="mfaSpinner">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <ng-template pTemplate="header">
        <div class="w-full text-center">
            <b class="text-3xl" >{{'login.mfa.forgot-pin' | translate}}</b>
            <div class="text-xl">{{'login.mfa.init-pin' | translate}}</div>
        </div>
    </ng-template>

    <p-steps [model]="routeItems" styleClass="mt-0" [readonly]="true" [activeIndex]="mfaResetPinAskActiveIndex"></p-steps>
    <br><br>
    <div *ngIf="mfaResetPinAskActiveIndex == 0" class="p-fluid p-formgrid grid">
        <div class="text-center flex justify-content-center align-items-center flex-column">
            <i class="ico-dark pi pi-lock pb-1 text-2xl"></i>
            <label class="label pb-3 pt-2">{{'login.mfa.id-conf' | translate}}</label>
        </div>
        <div class="col-12">
            <label class="label mb-2">{{'login.mfa.password' | translate}}</label>
            <p-password (keydown.enter)="validatePasswordSubmit()" id="password" placeholder="{{'login.pwd' | translate}}" [feedback]="false" [(ngModel)]="credentials.password" (ngModelChange)="resetLoginErrors()" [toggleMask]="true" inputStyleClass="w-full" styleClass="w-full" class="w-full"
                (onBlur)="passwordErrorRequired = isEmpty(credentials.password)" [ngClass]="{'ng-invalid ng-dirty': passwordErrorRequired}"></p-password>
            <small *ngIf="passwordErrorRequired" id="password-error" class="w-20rem p-error">{{'login.erreurs.champ-obligatoire' | translate}}</small>
            <small *ngIf="isUserLocked()" id="user-locked-error" class="w-20rem p-error">{{'login.erreurs.compte-verouillé' | translate}}</small>
            <small *ngIf="isUserInactive()" id="user-inactive-error" class="w-20rem p-error">{{'login.erreurs.compte-inactif' | translate}}</small>
            <small *ngIf="isUserNotFound()" id="user-not-found-error" class="w-20rem p-error">{{'login.erreurs.identifiant-pass-incorrect' | translate}}</small>
            <small *ngIf="isUserDesactivated()" id="user-desactivated-error" class="w-20rem p-error">{{'login.erreurs.desactivated' | translate}}</small>
        </div>
        <div class="col-12">
            <a class="text-primary hover:underline cursor-pointer font-medium" [routerLink]="['/auth/forgotpassword']" >{{'login.mot_de_passe_oublie' | translate}}</a>
        </div>
        <div class="col-12">
            <label>{{'login.mfa.input-required' | translate}}</label>
        </div>
    </div>
    <div *ngIf="mfaResetPinAskActiveIndex == 1" class="p-fluid p-formgrid grid">
        <div class="text-center flex justify-content-center align-items-center flex-column">
            <i class="ico-dark pi pi-key pb-1 text-2xl"></i>
            <label class="label pb-3 pt-2">{{'login.mfa.init-pin-code-title' | translate}}</label>
        </div>
        <div class="col-12 pb-0">
            <label class="label">{{'login.mfa.init-pin-code' | translate}} <i class="pi pi-info-circle" (click)="infoResetCode($event)"></i> </label>
            <p-confirmPopup [style]="{width: '15rem'}" key="infoResetCode"></p-confirmPopup>
            <input class="label" pInputText type="text" [(ngModel)]="resetCode" (ngModelChange)="clearResetCodeErrors()" placeholder="{{'login.mfa.init-pin-code-placeholder' | translate}}"
                (blur)="resetCodeErrorRequired = isEmpty(resetCode)" [ngClass]="{'ng-invalid ng-dirty': resetCodeErrorWrong || resetCodeErrorRequired}" />
            <small *ngIf="!resetCodeErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !resetCodeErrorRequired}">
                {{'login.erreurs.champ-obligatoire' | translate}}
            </small>
            <small *ngIf="resetCodeErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !resetCodeErrorWrong}">
                {{'login.mfa.activation-code-fail' | translate}}
            </small>
        </div>
        <p-divider layout="horizontal" class="w-full"></p-divider>
        <div class="col-12 pb-0">
            <label class="label">{{'login.mfa.new-pin' | translate}}</label>
            <p-password [(ngModel)]="resetPin" (keydown)="numbersOnly($event)" (ngModelChange)="clearResetPinErrors()" [toggleMask]="true" [feedback]="false" placeholder="{{'login.mfa.new-pin-placeholder' | translate}}"
                (onBlur)="resetPinErrorRequired = isEmpty(resetPin)" [ngClass]="{'ng-invalid ng-dirty': resetPinErrorWrong || resetPinErrorRequired}"></p-password>
            <small *ngIf="!resetPinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !resetPinErrorRequired}">
                {{'login.erreurs.champ-obligatoire' | translate}}
            </small>
            <small *ngIf="resetPinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !resetPinErrorWrong}">
                {{'login.mfa.pin-def-fail' | translate}}
            </small>
        </div>
        <div class="col-12 pb-0">
            <label class="label">{{'login.mfa.conf-pin' | translate}}</label>
            <p-password [(ngModel)]="confResetPin" (keydown)="numbersOnly($event)" (ngModelChange)="clearConfResetPinErrors()" [toggleMask]="true" [feedback]="false" placeholder="{{'login.mfa.conf-pin-placeholder' | translate}}"
                (onBlur)="confResetPinErrorRequired = isEmpty(confResetPin)" [ngClass]="{'ng-invalid ng-dirty': confResetPinErrorWrong || confResetPinErrorRequired}"></p-password>
            <small *ngIf="!confResetPinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !confResetPinErrorRequired}">
                {{'login.erreurs.champ-obligatoire' | translate}}
            </small>
            <small *ngIf="confResetPinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !confResetPinErrorWrong}">
                {{'login.mfa.pin-conf-fail' | translate}}
            </small>
        </div>
        <div class="col-12">
            <label>{{'login.mfa.input-required' | translate}}</label>
        </div>
    </div>
    <div *ngIf="mfaResetPinAskActiveIndex == 2" class="p-fluid p-formgrid grid">
        <div class="text-center flex justify-content-center align-items-center flex-column w-full">
            <i class="ico-dark pi pi-check pb-1 text-2xl"></i>
            <label class="label pt-2">{{'login.mfa.init-pin-success-title' | translate}}</label>
            <label class="label pb-3">{{'login.mfa.init-pin-success-subtitle' | translate}}</label>
        </div>
        <div class="col-12 pb-0 text-center">
            <img class="w-12rem" [src]="'assets/layout/images/mfa_reset_pin_success.svg'"/>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="w-full">
            <button *ngIf="mfaResetPinAskActiveIndex == 0" id="connexion" pButton label="Suivant" type="button" icon="pi pi-arrow-right" class="mr-0"
             iconPos="right" (click)="validatePasswordSubmit()"></button>
            <button *ngIf="mfaResetPinAskActiveIndex == 1" id="connexion" pButton label="Suivant" type="button" icon="pi pi-arrow-right" class="mr-0"
             iconPos="right" (click)="resetPinSubmit()"></button>
            <button *ngIf="mfaResetPinAskActiveIndex == 2" id="connexion" pButton label="Fermer" type="button" icon="pi pi-check" class="mr-0"
             (click)="resetPinHide()"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog #userBlockedPopup [(visible)]="mfaUserBlockedAsk" [modal]="true" (onShow)="clearState()" [closable]="true" showEffect="fade" [style]="{'width': '25rem'}">
    <div class="mfa-spinner" *ngIf="mfaSpinner">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <ng-template pTemplate="header">
        <div class="w-full text-center">
            <b class="text-3xl" >{{'login.mfa.user-blocked-title' | translate}}</b>
        </div>
    </ng-template>
    <div class="col-12 pb-5 text-center">
        <label class="text-xl p-error">{{'login.mfa.user-blocked-subtitle' | translate}}</label>
        <label class="text-xl p-error">{{'login.mfa.user-blocked-subtitle-phone' | translate}}</label>
    </div>
    <div class="col-12 pb-0 text-center">
        <img class="w-16rem" [src]="'assets/layout/images/mfa_account_locked.svg'"/>
    </div>
    <ng-template pTemplate="footer">
        <div class="w-full">
            <button pButton label="Fermer" type="button" class="mr-0"
             (click)="userBlockedPopup.close($event)"></button>
        </div>
    </ng-template>
</p-dialog>

<div class="flex h-screen" [ngClass]="{'87SnUZ7TrBpM' : isManager}" >
    <div class="w-full xl:w-4 h-full text-center px-6 py-6 flex flex-column justify-content-between">
      <div >
        <img [src]="'assets/layout/images/logo-dark.svg'" class="login-logo" alt="diamond-layout" />
      </div>
        <ng-container *ngIf="mfaGlobalSpinner">
            <p-progressSpinner></p-progressSpinner>
        </ng-container>
        <div *ngIf="!mfaGlobalSpinner" class="flex flex-column align-items-center gap-4">
            <div class="mb-3">
                <h2 id="login">{{'login.connexion' | translate}}</h2>
                <p>
                    <a *ngIf="!mfaLoginAsk" class="text-primary hover:underline cursor-pointer font-medium" [routerLink]="['/auth/forgotpassword']" >{{'login.mot_de_passe_oublie' | translate}}</a>
                    <a *ngIf="mfaLoginAsk" class="text-primary hover:underline cursor-pointer font-medium" (click)="resetPinShow()">{{'login.pin_oublie' | translate}}</a>
                </p>
            </div>
            <div *ngIf="mfaLoginAsk" class="w-20rem" outsideClick (outsideClick)="pinContainerHideFromLogin()">
                <p-dropdown #usernameDropdown [options]="mfaLoginList" [(ngModel)]="credentials.username" [editable]="false" [style]="{'width':'100%'}" (onHide)="addNewUserHide()" [showClear]="false">
                    <ng-template pTemplate="footer">
                        <p-divider layout="horizontal" styleClass="m-0"></p-divider>
                        <div class="p-3">
                            <p-button *ngIf="!mfaNewUserAsk" (click)="addNewUserShow($event)" styleClass="p-button-text">
                               <span class="flex align-items-center justify-content-center w-15rem">
                                <i class="pi pi-plus mr-2"></i>
                                <span>{{'login.mfa.new-user' | translate}}</span>
                               </span>
                            </p-button>
                            <div *ngIf="mfaNewUserAsk" class="p-inputgroup">
                                <input selfFocus (click)="preventEvent($event)" (keydown.enter)="addNewUser($event, usernameDropdown)"
                                pInputText id="add-username-input" placeholder="{{'login.email' | translate}}"
                                [(ngModel)]="newUsername" class="w-full text-center"/>
                                <button type="button" (click)="addNewUser($event, usernameDropdown);" pButton icon="pi pi-check"></button>
                            </div>
                        </div>
                    </ng-template>
                </p-dropdown>
                <br><br>
                <div class="p-fluid p-formgrid grid">
                    <div class="col-12">
                        <input pInputText #pinContainerInput [(ngModel)]="pin" class="text-center"
                        [ngClass]="{'pin-container-box-show' : pinContainerShow}"
                        [ngClass]="{'ng-invalid ng-dirty': pinErrorWrong || pinErrorRequired}"
                        [readOnly]="true" (click)="pinContainerClick()" (ngModelChange)="clearPinErrors()"
                        type="{{ pinInputTypePassword ? 'password' : 'text' }}"
                        (focus)="pinContainerInput.blur()"
                        placeholder="Saisissez votre code PIN"/>
                    </div>
                </div>
                <div class="pin-container-box" [ngClass]="{'pin-container-box-hide' : !pinContainerShow}">
                    <div class="pin-container gap-3">
                        <div *ngFor="let pinInput of pinInputList" pInputText (click)="pinInputClick(pinInput)"
                         class="pin-btn flex justify-content-center align-items-center cursor-pointer select-none"> {{pinInput}}
                        </div>
                        <div pInputText (click)="pinInputHideClick()"
                        class="pin-btn flex justify-content-center align-items-center cursor-pointer select-none">
                        <i *ngIf="pinInputTypePassword" class="pi pi-eye"></i>
                        <i *ngIf="!pinInputTypePassword" class="pi pi-eye-slash"></i>
                       </div>
                        <div pInputText (click)="pinContainerClear()"
                        class="pin-btn-dark flex justify-content-center align-items-center cursor-pointer no-hover select-none text-white">
                          {{ 'login.mfa.delete-btn' | translate }}
                       </div>
                    </div>
                </div>
                <small *ngIf="!pinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinErrorRequired}">
                    {{'login.erreurs.champ-obligatoire' | translate}}
                </small>
                <small *ngIf="pinErrorWrong" class="w-20rem p-error" [ngClass]="{'soft-hidden': !pinErrorWrong}">
                    {{'login.mfa.pin-fail' | translate}}
                    <br>
                    {{'login.mfa.pin-fail-retry' | translate}}
                </small>
            </div>
            <ng-container *ngIf="!mfaLoginAsk">
                <input (keydown.enter)="authenticate()" pInputText id="email" placeholder="{{'login.email' | translate}}" [(ngModel)]="credentials.username" (ngModelChange)="resetLoginErrors(); trackUsernameInput(credentials.username)" class="w-20rem"
                [ngClass]="{'error-contour':credentials.username == (null || ''||undefined) && submitted } "/>
                <small *ngIf="(credentials.username == null || credentials.username === '' || credentials.username === undefined) && submitted" id="user-not-found-error" class="w-20rem p-error">{{'login.erreurs.champ-obligatoire' | translate}}</small>
            </ng-container>

            <p-password  *ngIf="!mfaLoginAsk"  (keydown.enter)="authenticate()" id="password" placeholder="{{'login.pwd' | translate}}" [feedback]="false" [(ngModel)]="credentials.password" (ngModelChange)="resetLoginErrors()" [toggleMask]="true" inputStyleClass="w-20rem"
            [ngClass]="{'error-contour':credentials.password == (null || ''||undefined) && submitted} "></p-password>
            <small *ngIf="(credentials.password == null || credentials.password === '' || credentials.password === undefined) && submitted" id="password-error" class="w-20rem p-error">{{'login.erreurs.champ-obligatoire' | translate}}</small>
          <small *ngIf="isUserLocked() && !mfaResetPinAsk && !mfaLoginAsk" id="user-locked-error" style="white-space: pre-line" class="w-20rem p-error">{{'login.erreurs.compte-verouillé' | translate}}</small>
          <small *ngIf="isUserInactive() && !mfaResetPinAsk && !mfaLoginAsk" id="user-inactive-error" class="w-20rem p-error">{{'login.erreurs.compte-inactif' | translate}}</small>
          <small *ngIf="isUserNotFound() && !mfaResetPinAsk && !mfaLoginAsk" id="user-not-found-error" class="w-20rem p-error">{{'login.erreurs.identifiant-pass-incorrect' | translate}}</small>
          <small *ngIf="isUserDesactivated() && !mfaResetPinAsk && !mfaLoginAsk" id="user-desactivated-error" class="w-20rem p-error">{{'login.erreurs.desactivated' | translate}}</small>
          <button *ngIf="!mfaLoginAsk" id="connexion" pButton label="Je me connecte" type="button" [loading]="loading" iconPos="right" (click)="authenticate()" class="w-20rem"></button>
          <button *ngIf="mfaLoginAsk" id="connexion" pButton label="Je me connecte" type="button" [loading]="loading" iconPos="right" (click)="mfaLogin()" class="w-20rem"></button>
          <p-messages *ngIf="accountSyncWarnAsk" severity="warn" class="w-20rem" [closable]="false">
            <ng-template pTemplate>
              <i class="pi pi-exclamation-triangle"></i>
              <div class="ml-2">
                {{'login.mfa.sync-warn-desc' | translate}} <br> <strong><span class="link-button" (click)="reload()">{{'login.mfa.sync-warn-action' | translate}}</span></strong>
              </div>
            </ng-template>
          </p-messages>
          <button *ngIf="!hidePremConxProcess" id="first-connexion" pButton label="Première connexion" type="button"  iconPos="right" (click)="premiereConnexion()" class="w-20rem p-button-outlined"></button>
        </div>
      <p id="informative-text" class="text-color-secondary font-semibold">{{'login.info9' | translate}} <span id="lien" class=" underline cursor-pointer" (click)="showInfo()" >{{'login.info10' | translate}}</span></p>
      <div>
        <span class="footer-copyright">Tessi - {{currentYear}}<br>{{appVersion}}
        </span>
      </div>
    </div>

  <app-page-login-img class="w-8 hidden lg:flex flex-column justify-content-between" [pageLogin]="pageLogin" [imageSrc]="imageSrc" [isVisible] = "isVisible" ></app-page-login-img>

</div>

<app-page-login-popups (popupsInfo)="getPopupInfo($event)" (popupsFirstConnection)="getPopupFirstConnection($event)"
    [popupType]="popupType"></app-page-login-popups>

<!--  START  Info dialog pour Cliquez ici -->

<app-info-dialog [popupsInfo]="popupsInfo" [display_dialog_info]="display_dialog_info"
    (closed)="dialogInfoClose($event)"></app-info-dialog>
<!--  END  Info dialog pour Cliquez ici -->

<!--  START  Premiere connexion dialog -->
<p-dialog header="Title" [(visible)]="display_premiere_connexion" [modal]="true"
    [breakpoints]="{'1100px': '75vw', '640px': '100vw'}" [style]="{width: '35vw'}">
  <ng-template pTemplate="header">
    <h3 id="title-popup">{{popupsFirstConnection?.title}}</h3>
  </ng-template>
  <p id="popup-content" [innerHTML]="safeHtml"></p>
  <ng-template pTemplate="footer">
<div class="button-container">
            <button pButton pRipple (click)="navigateToPremiereConnexion(false)" type="button" label="Non" id="close"
                icon="pi pi-times" class="p-button-text" iconPos="left"></button>
            <button pButton pRipple (click)="navigateToPremiereConnexion(true)" type="button" label="Oui" id="redirection"
                icon="pi pi-check" class="p-button-text" iconPos="left"></button>
        </div>
    </ng-template>
</p-dialog>
<!--  END  Premiere connexion dialog -->

<p-confirmDialog [baseZIndex]="10000" [style]="{ width: '30rem' }" key="confirmForgotPin"></p-confirmDialog>

<p-toast position="top-right" key="ERROR_TOKEN"></p-toast>
<p-toast position="top-right" key="SUCCESS_ACTIVATION_ACCOUNT"></p-toast>
<p-toast position="top-right" key="adhesion"></p-toast>
